/**
 * dashboardConfig.js
 * URLs exclusivas para Dashboard V2 / LobbyV2.
 *
 * Para pasar de local → subdominio v3, solo cambia estas dos líneas:
 *   portalManager: "https://backendv3.portalmanager.pro"
 *   globalSales:   "https://apiglobalsalesv2.mayaland.store"
 *
 * El resto de la app sigue usando backEndLink.js (backv2) y el URL de
 * getInformationWithDataGlobalSales (apiglobalsales.mayaland.store).
 */

const dashboardConfig = {
  portalManager: "https://backv3.portalmanager.pro",  // PRODUCCION V3 (futuro)
  // portalManager: "http://localhost:4820",                   // LOCAL

  globalSales: "https://globalv3.portalmanager.pro", // PRODUCCION V3 (futuro)
  // globalSales: "http://localhost:3600",                     // LOCAL
};

export default dashboardConfig;
